import React, { useState, useEffect } from 'react';
import {
  useTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';

const SelectField = ({
  value: initialValue = '',
  onChange,
  name,
  label,
  options,
  icon,
  variant,
  required,
  errorMessage,
  // false: esconde o rótulo quando já há valor (o rótulo "flutuante" é branco,
  // pensado para o fundo azul da home; em fundo claro ele some/sobrepõe).
  floatingLabel = true,
  ...props
}) => {
  const [localValue, setLocalValue] = useState(initialValue || '');

  useEffect(() => {
    setLocalValue(initialValue || '');
  }, [initialValue]);

  const theme = useTheme();

  const handleSelectChange = (event) => {
    const { value } = event.target;

    setLocalValue(value);

    if (onChange) {
      onChange(event);
    }
  };

  return (
    <FormControl fullWidth error={!!errorMessage}>
      <InputLabel
        id={`${name}-select-label`}
        shrink={!!localValue}
        sx={{
          color: localValue
            ? theme.palette.primary.contrastText
            : theme.palette.primary.main,
          transform: localValue
            ? 'translate(0, -1.5rem)'
            : 'translate(1rem, 0.75rem)',
          transition: 'all 0.2s ease-in-out',
          display: !floatingLabel && localValue ? 'none' : undefined,
        }}
      >
        {required ? `${label} *` : label}
      </InputLabel>
      <Select
        labelId={`${name}-select-label`}
        id={`${name}-select`}
        value={localValue}
        name={name}
        IconComponent={() => (
          <img src={icon} alt="" style={{ marginRight: '1rem' }} />
        )}
        onChange={handleSelectChange}
        sx={{
          backgroundColor:
            variant === 'light grey' ? theme.palette.grey[50] : '#FFFFFF',
          color: '#000000',
          borderRadius: '8px',
          height: '45px',

          border: 'none',
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
      >
        <MenuItem value="">
          <em>Selecione um {label.toLowerCase()}</em>
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option} value={option} sx={{ color: '#000000' }}>
            {option}
          </MenuItem>
        ))}
      </Select>
      {errorMessage && (
        <FormHelperText
          sx={{
            color: theme.palette.error.main,
            margin: '4px 0 0 14px',
            backgroundColor:
              variant === 'light grey' ? theme.palette.grey[50] : '#FFFFFF',
            padding: '2px 8px',
            borderRadius: '0 0 8px 8px',
          }}
        >
          {errorMessage}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default SelectField;
